var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMercado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2536 12.7134C20.8006 12.9984 20.2218 12.9984 19.7688 12.7134L17.529 11.4233L15.5711 12.7134C15.1181 12.9984 14.5393 12.9984 14.0863 12.7134L11.9724 11.4233L9.88865 12.7134C9.43566 12.9984 8.8568 12.9984 8.40382 12.7134L6.2899 11.4233L4.20615 12.7134C3.75316 12.9984 3.17436 12.9984 2.72138 12.7134L1 11.6234V29.6397C1 30.7348 1.89589 31.6249 2.99817 31.6249H21.2184C22.3207 31.6249 23.2165 30.7348 23.2165 29.6397V11.4633L21.2435 12.7134H21.2536Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43604 19.544V26.6096",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1167 19.544V26.6096",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8008 19.544V26.6096",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3469 10.028L11.7613 6.59772",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00613 8.57785V7.30273C9.00613 6.47266 8.32664 5.79761 7.49113 5.79761H3.77159C2.93608 5.79761 2.25659 6.47266 2.25659 7.30273V11.958C2.25659 12.1381 2.29186 12.3131 2.35225 12.4731L2.72974 12.7131C3.18273 12.9981 3.76153 12.9981 4.21451 12.7131L6.29827 11.423L5.84526 11.7031C6.33349 10.223 7.5163 9.05288 9.00613 8.57785Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40515 12.7141C8.45568 12.7442 8.50118 12.7693 8.55676 12.7944C8.50623 12.7693 8.45568 12.7442 8.40515 12.7141Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33345 3.36685H3.8606V5.79202H7.33345V3.36685Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 8.32801C16.0247 6.9729 16.4827 5.72777 17.0062 4.66269C16.5079 4.16265 15.8133 3.85764 15.0533 3.85764C14.9325 3.85764 14.8116 3.86766 14.6959 3.88266C14.3838 2.70757 13.3118 1.84247 12.0333 1.84247C10.7549 1.84247 9.67779 2.71257 9.37077 3.88266C9.255 3.86766 9.13423 3.85764 9.01343 3.85764C8.38428 3.85764 7.81047 4.06765 7.34741 4.41768V5.79278H7.50347C8.33898 5.79278 9.01847 6.46784 9.01847 7.2979V8.57802C9.49159 8.42301 9.99994 8.33796 10.5284 8.33796C12.6877 8.33796 14.5197 9.72306 15.1791 11.6482C15.2445 10.6081 15.4156 9.48309 15.7025 8.32801H15.6875Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29626 11.4223L8.41018 12.7123C8.86317 12.9974 9.44202 12.9974 9.89501 12.7123L11.9788 11.4223L14.0927 12.7123C14.4903 12.9674 14.9886 12.9924 15.4114 12.8024C15.1949 10.3022 13.086 8.34201 10.5141 8.34201C8.33471 8.34201 6.48751 9.75216 5.84326 11.7023L6.29626 11.4223Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8008 8.73794L20.6446 8.05789",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3409 6.19704L21.1847 5.52194",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.373 12.814C15.373 12.814 15.3481 12.824 15.3381 12.829C15.3481 12.829 15.363 12.819 15.373 12.814Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0664 1.04218C19.2091 0.587141 16.8033 3.84742 15.691 8.32776C15.4041 9.48785 15.2329 10.6179 15.1675 11.658C15.2933 12.018 15.3789 12.398 15.4141 12.7931C15.4695 12.7681 15.5248 12.743 15.5802 12.708L17.5381 11.418L19.7779 12.708C20.2309 12.9931 20.8097 12.9931 21.2627 12.708L21.62 12.483C21.927 11.708 22.2039 10.8629 22.4253 9.97284C23.5377 5.49251 22.9337 1.4922 21.0765 1.03717L21.0664 1.04218Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercado);
export default __webpack_public_path__ + "static/media/mercado.4ca7fbe4805d9c7ea16a7281ab9d8355.svg";
export { ForwardRef as ReactComponent };